import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const AdminUtteranceConfidencePage = () => {
  return (
    <>
      <Helmet>
        <title>Utterance inspector - AutoScript Admin</title>
      </Helmet>
      <Header title="Utterance inspector" />

      <PageProvider>
        <Content />
      </PageProvider>
    </>
  );
};
